module.exports = __webpack_public_path__ + "static/media/privacy.feb8a1e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/account/assets/images/privacy.png
// module id = 1259
// module chunks = 2